import { FC } from 'react';

import { styled } from '../../theme';
import Button, { ButtonProps } from '../Button';
import { PAGINATION_CONTROL_HEIGHT } from './constants';

type Props = Omit<ButtonProps, 'onClick'> & {
    'aria-label': string;
    onClick: () => void;
    variant?: 'text' | 'icon';
};

const StyledControlButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'variant',
})<{
    variant?: 'text' | 'icon';
}>(({ variant = 'text' }) => {
    const isIcon = variant === 'icon';

    return {
        minWidth: 0,
        width: isIcon ? PAGINATION_CONTROL_HEIGHT : 'auto',
        minHeight: PAGINATION_CONTROL_HEIGHT,
        height: PAGINATION_CONTROL_HEIGHT,
        padding: isIcon ? 0 : '0 12px',
    };
});

const PaginationControlButton: FC<Props> = ({ children, variant, ...props }) => (
    <StyledControlButton color="base" size="xs" variant={variant} {...props}>
        {children}
    </StyledControlButton>
);

export default PaginationControlButton;
